import { Autocomplete, FormControl, TextField } from "@mui/material";

const STATE_OF_MATTER_OPTIONS = [
  { value: "SOLID", label: "Solid" },
  { value: "LIQUID", label: "Liquid" },
  { value: "GAS", label: "Gas" },
];

export function StateOfMatterPicker({
  value,
  onChange,
}: {
  value?: string[] | null;
  onChange: (states: string[]) => void;
}) {
  const handleChange = (
    event: React.SyntheticEvent<Element, Event>,
    changeValue: ({ value: string; label: string } | undefined)[]
  ) => {
    const validValues = changeValue
      .filter((option): option is { value: string; label: string } => option !== undefined)
      .map((option) => option.value)
      .sort();
    onChange(validValues);
  };

  // Convert string values to option objects for the Autocomplete
  const selectedOptions =
    value
      ?.map((v) => STATE_OF_MATTER_OPTIONS.find((opt) => opt.value === v))
      .filter((option): option is { value: string; label: string } => option !== undefined) || [];

  return (
    <FormControl fullWidth>
      <Autocomplete
        size="small"
        multiple
        options={STATE_OF_MATTER_OPTIONS}
        value={selectedOptions}
        getOptionLabel={(option) => {
          if (typeof option === "string") {
            return STATE_OF_MATTER_OPTIONS.find((opt) => opt.value === option)?.label || option;
          }
          return option?.label || "";
        }}
        isOptionEqualToValue={(option, value) => {
          return option.value === value?.value;
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="State of Matter"
            autoComplete="off"
            inputProps={{
              ...params.inputProps,
              autoComplete: "off",
              "data-lpignore": "true",
              "data-form-type": "other",
            }}
          />
        )}
        onChange={handleChange}
      />
    </FormControl>
  );
}
